import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-license-history',
  templateUrl: './license-history.component.html',
  styleUrls: ['./license-history.component.css']
})
export class LicenseHistoryComponent implements OnInit {

  constructor(private route: ActivatedRoute) {
    this.route.parent.params.subscribe(params => { });

  }

  ngOnInit(): void {
  }

}
